import { call, put, takeEvery } from 'redux-saga/effects'
import loginActions from './loginActions'
import loginTypes from './loginTypes'
import LoginService from '../../services/LoginService'
import { storeSave, storeRemove, saveSecureStorage } from '../../tools/storage'
import { formatSaveStorage } from '../../tools/dataParse'
import ENV from '../../config/env'

function * Login ({ payload, callback }) {
  try {
    const { data } = yield call(LoginService.login, payload)

    if (data.type === ENV.DUT) {
      storeSave(ENV.DUT, ENV.UTV)
    } else {
      storeSave(ENV.NUT, ENV.UTV)
    }
    const user = formatSaveStorage(data)
    yield saveSecureStorage(payload, 'utils')
    yield put(loginActions.loginSuccess(user))
    yield storeSave(user)
    if (callback) yield callback(user.email)
  } catch ({ message }) {
    yield put(loginActions.loginFailure(message))
  }
}

function * Logout () {
  yield storeRemove()
  yield storeRemove('utils')
}

export function * onLogin () {
  yield takeEvery(loginTypes.LOGIN, Login)
}

export function * onLogout () {
  yield takeEvery(loginTypes.LOGOUT, Logout)
}

export function * loginSaga () {
  yield takeEvery(loginTypes.LOGIN, Login)
  yield takeEvery(loginTypes.LOGOUT, Logout)
}
